
import { Component, Emit, Prop, Vue, Model } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class FormSelect extends Vue {
  created() {}

  mounted() {}

  updated() {}

  destroyed() {}
}
